module.exports = __webpack_public_path__ + "resources/img/img_security_dfinder_fds_m.30fba729abc28a9fd9c5037316a52113.png";